export default "<app-header></app-header>\n<app-transaction-form></app-transaction-form>\n"